import { useMemo } from 'react';
import { Dimensions } from 'react-native';
import { useMMKVNumber } from 'react-native-mmkv';

export default function useScale() {
  const [f] = useMMKVNumber('fontSize');

  const scale = useMemo(
    () => (window as any).idcScale ?? Dimensions.get('window').scale,
    [],
  );
  const fontScale = f ?? 1;

  const result = useMemo(() => [scale, fontScale], [scale, fontScale]);
  return result;
}
